import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Text } from 'components/base'

class StatusCard extends Component {
  static propTypes = {
    unit: PropTypes.string,
    limit: PropTypes.number,
    Icon: PropTypes.any.isRequired,
    current: PropTypes.any.isRequired,
    description: PropTypes.any.isRequired,
  }

  render() {
    const { title, Icon, current, limit, unit, description } = this.props

    return (
      <div
        style={{ width: 350 }}
        className="radius-normal padding-vertical-normal padding-right-largest font-family-system"
      >
        <Text.Section className="margin-bottom-normal">{title}</Text.Section>
        <div className="flexbox flexbox-align-center margin-bottom-small">
          <Icon size={16} className="margin-right-small shade-30" />
          <div className="shade-20 font-size-normal font-weight-bold">
            {current}
          </div>
          {limit &&
            unit && (
              <div className="shade-30 font-size-normal">
                /{limit} {unit}
              </div>
            )}
        </div>
        <div className="shade-20 font-weight-medium line-height-largest">
          {description}
        </div>
      </div>
    )
  }
}

export default StatusCard
